import { api } from "./api";

let cfg = null;
export const paymentConfig = async () => {
  if (!cfg) cfg = api.get("/wallet/payment-config").then((r) => r.data).catch(() => { cfg = null; return { provider: "simulated" }; });
  return cfg;
};

// DOKU: redirect to the hosted checkout (returns null). Simulated: credits instantly (returns the API result).
export async function buyPackage(pkg) {
  const c = await paymentConfig();
  if (c.provider === "doku") {
    const r = await api.post("/wallet/doku/checkout", { package_id: pkg.id });
    window.location.assign(r.data.payment_url);
    return null;
  }
  const r = await api.post("/wallet/topup", { package_id: pkg.id });
  return r.data;
}
